import { IAPIDalliList, ICalculatorItem } from '../../redux/services/Interfaces';
import { DeclOfNum } from '../../services/GlobalFunctions';
import {content} from "../../services/content";

export const GetNamePartner = (name: string) => {
  let namePartner = '',
    logoPartner = '';
  switch (name) {
    case 'DS':
      namePartner = 'Dalli';
      logoPartner = require('./img/dalli.png');
      break;
    case 'SDEK':
      namePartner = 'CDEK';
      logoPartner = require('./img/cdek.png');
      break;
    case 'BOXBERRY':
      namePartner = 'Boxberry';
      logoPartner = require('./img/boxberry.png');
      break;
    case '5POST':
      namePartner = '5 Post';
      logoPartner = require('./img/5-post-described.svg').default;
      break;
    case 'rupost':
      namePartner = 'Почта России';
      logoPartner = require('./img/ru-post.png');
      break;
    default:
      namePartner = name;
  }

  return logoPartner !== '' ? <img src={logoPartner} alt="logo" /> : <p className="body2">{namePartner}</p>;
};

export const GetDays = (arrPartners: ICalculatorItem[]) => {
  const arr: IAPIDalliList[] = arrPartners.reduce((result: any, item) => {
    return item.price ? [...result, item.price].flat() : result;
  }, []);

  const arrFix: string[] = arr.reduce((result: any, item) => {
    return [...result, item.delivery_period];
  }, []);

  const minDays: number[] = [];
  const maxDays: number[] = [];
  arrFix.forEach((item) => {
    const arrSplit = item.split('-');

    if (arrSplit.length === 1) {
      minDays.push(parseInt(arrSplit[0]));
      maxDays.push(parseInt(arrSplit[0]));
    } else {
      minDays.push(parseInt(arrSplit[0]));
      maxDays.push(parseInt(arrSplit[1]));
    }
  });

  if (!maxDays.length) {
    return '-1';
  }

  const min = Math.min.apply(null, minDays);
  const max = Math.max.apply(null, maxDays);

  return min === max
    ? `${max} ${DeclOfNum(max, content.common.wordsDay)}`
    : `${min}-${max} ${DeclOfNum(max, content.common.wordsDay)}`;
};

export const GetTypeDays = (days: string) => {
  const arrSplit = days.split('-');
  let num = 0;

  if (arrSplit.length === 1) {
    num = parseInt(arrSplit[0]);
  } else {
    num = parseInt(arrSplit[1]);
  }

  return DeclOfNum(num, content.common.wordsDay);
};

/* old ---> */

export const GetMinPrice = (arrPartners: ICalculatorItem[]) => {
  const arr: IAPIDalliList[] = arrPartners.reduce((result: any, item) => {
    return item.price ? [...result, item.price].flat() : result;
  }, []);

  const arrFix: number[] = arr.reduce((result: any, item) => {
    return [...result, parseInt(item.price)];
  }, []);

  return Math.min.apply(null, arrFix);
};
